import { MessageCallReceived, MessageIncomingEvent } from '@wui/im'

export enum EmitterEvents {
  NEW_MESSAGE = 'newMessage',
  UPDATE_STATUS = 'updateStatus',
  REMOTE_BUSY = 'remoteBusy',
  TOGGLE_MUTE_VIDEO_IN_CONFERENCE = 'toggleMuteVideoInConference',
  TOGGLE_SCREEN_SHARING_IN_CONFERENCE = 'toggleScreenSharingInConference',
  RECORD_ITEM_CONTROL = 'recordItemControl',
  REMOVE_MEMBER = 'removeMember',
  DELETE_ROOM = 'deleteRoom',
  CHANGE_ACTIVE_PARTICIPANTS_COUNT_IN_ACTIVE_ROOM = 'changeActiveParticipantsCountInActiveRoom',
  OPEN_CHAT_ASIDE = 'openChatAside',
  /** Guest kicked / conference removed — navigate to BYE then logout (layout-guest). */
  GUEST_FORCED_EXIT = 'guestForcedExit',
  /** Leave current chat route if it matches roomRouteId (layout-application). */
  LEAVE_CHAT_IF_CURRENT = 'leaveChatIfCurrent',
}

export type LeaveChatIfCurrentPayload = {
  roomRouteId: string
  /** Set by LEAVE_CHAT_IF_CURRENT handler when navigation away from the chat happened. */
  didLeave?: boolean
}

export interface NewMessageEmitterEvent {
  roomId?: string,
  event: MessageIncomingEvent | MessageCallReceived
}

export interface ChangeActiveParticipantsCountInActiveRoomEvent {
  roomPServed: string,
  count: number
}
